import { fetchApi } from "./api";

export type AiaAwardInput = {
  category: "industry" | "leadership";
  name: string;
  description?: string | null;
  image_path?: string | null;
  article_url?: string | null;
  display_order?: number;
  is_active?: boolean;
};

export const listAiaAwards = () =>
  fetchApi<any[]>("people", "listAiaAwards", {}, { auth: false });

export const listAiaAwardsAdmin = () =>
  fetchApi<any[]>("people", "listAiaAwardsAdmin", {});

export const createAiaAward = (opts: { data: AiaAwardInput }) =>
  fetchApi<any>("people", "createAiaAward", opts.data);

export const updateAiaAward = (opts: { data: AiaAwardInput & { id: string } }) =>
  fetchApi<any>("people", "updateAiaAward", opts.data);

export const deleteAiaAward = (opts: { data: { id: string } }) =>
  fetchApi<{ ok: true }>("people", "deleteAiaAward", opts.data);
